import React from "react";
import { Button } from "risa-oasis-ui_v2";
import "./DeleteStepConfirmationDialog.scss";

interface DeleteStepConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  stepTitle: string;
  stepIndex: number;
  loading?: boolean;
}

const DeleteStepConfirmationDialog: React.FC<
  DeleteStepConfirmationDialogProps
> = ({ isOpen, onClose, onConfirm, stepTitle, stepIndex, loading = false }) => {
  if (!isOpen) return null;

  return (
    <div className="delete-step-dialog-overlay" onClick={onClose}>
      <div className="delete-step-dialog" onClick={(e) => e.stopPropagation()}>
        {/* <div className="delete-step-dialog__header">
          <h3 className="delete-step-dialog__title">Delete Process Step</h3>
        </div> */}

        <div className="delete-step-dialog__content">
          <div className="delete-step-dialog__warning">
            <div className="delete-step-dialog__warning-icon">⚠️</div>
            <div className="delete-step-dialog__warning-text">
              <p>Are you sure you want to delete this process step?</p>
              <p className="delete-step-dialog__warning-note">
                This action cannot be undone.
              </p>
            </div>
          </div>

          <div className="delete-step-dialog__step-info">
            <div className="delete-step-dialog__step-preview">
              <div className="delete-step-dialog__step-number">
                Step {stepIndex + 1}
              </div>
              <div className="delete-step-dialog__step-details">
                <h4 className="delete-step-dialog__step-title">{stepTitle}</h4>
                <p className="delete-step-dialog__step-description">
                  This step will be permanently removed from the process
                  configuration. All subsequent steps will be renumbered
                  automatically.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="delete-step-dialog__actions">
          <Button
            onClick={onClose}
            buttonType="secondary"
            size="medium"
            disabled={loading}
          >
            Cancel
          </Button>
          <div className="delete-step-dialog__delete-button">
            <Button
              onClick={onConfirm}
              buttonType="primary"
              size="medium"
              disabled={loading}
            >
              {loading ? "Deleting..." : "Delete Step"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteStepConfirmationDialog;
